import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

/**
 * Helper component to get the active camera.
 *
 * This component adds a bit of reusable code for getting the object for the active camera.
 */
export class ActiveCamera extends Component {
    static TypeName = 'active-camera';

    @property.object()
    nonVrCamera?: Object3D;

    @property.object()
    leftEye?: Object3D;

    start(): void {
        if (!this.nonVrCamera) {
            throw new Error('active-camera: nonVrCamera not set');
        }

        if (!this.leftEye) {
            throw new Error('active-camera: leftEye not set');
        }
    }

    getActiveCamera(): Object3D {
        return this.engine.xr?.session ? this.leftEye! : this.nonVrCamera!;
    }
}
